<div class="content-wrapper-inner">
    <div class="page-content">
        <div class="table-topbar mb-20">
            <div class="search-panel w-25">
                <div class="search-control w-100">
                    <span class="icon-search"></span>
                    <input type="search" class="form-control table-search" placeholder="Search" [formControl]="searchControl" />
                </div>
            </div>
            <div class="table-action-holder">
                <div class="create">
                    <a [routerLink]="['/pricing-general/create']" class="btn btn-primary py-10 px-15"><span class="icon-add"></span>Create payment plan</a>
                </div>
            </div>
        </div>
        <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
            <app-pricing-group-table (actions)="groupAction($event)"></app-pricing-group-table>
        </div>
    </div>
</div>
